<template>
  <toaster @close-toaster="closeSummaryToaster">
    <template v-slot:text>
      <span>{{ text }}</span>
    </template>
  </toaster>
</template>

<script>
import EventBus from '@/event-bus/event-bus';
import Toaster from '../../../../../../base-components/Toaster';

export default {
  name: 'MoveToFixedToaster',
  components: {
    Toaster,
  },
  props: {
    isIncome: {
      type: Boolean,
      required: true,
    },
    isFixed: {
      type: Boolean,
      required: true,
    },
    isSavings: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    text() {
      if (this.isFixed) {
        return this.isIncome ? 'ההכנסה שויכה להכנסה קבועה אחרת' : 'ההוצאה שויכה להוצאה קבועה אחרת';
      }
      if (this.isSavings) {
        return 'ההפקדה שויכה להפקדה קבועה';
      }
      return this.isIncome ? 'ההכנסה שויכה להכנסה קבועה' : 'ההוצאה שויכה להוצאה קבועה';
    },
  },
  methods: {
    closeSummaryToaster() {
      EventBus.$emit('close-toaster');
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
